import React from 'react';
import './App.css';
import AppRoutes from './components/AppRoutes';
import theme from './theme/theme_config';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import "@fontsource/roboto";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
